import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { notification } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';
import { useFilterGrid } from 'hooks/useFilterGrid';
import * as selectorsGlobal from '@redux/global/selectors';
import { useDownloadUserInfoGrid } from 'pages/user-maintenance/queries';

import Messages from 'i18n/messages/maintenance';

const ExportUserButton = () => {
  const intl = useIntl();

  const { gridFilters } = useFilterGrid({ entityType: 'userMaintenance' });
  const { userMaintenanceText } = useSelector(
    selectorsGlobal.selectSelectSearchText()
  );

  const { mutate: downloadUserInfoGrid, isLoading: isExporting } =
    useDownloadUserInfoGrid();

  const getFilterParams = () => {
    let filterRoles = [];
    let filterParams = [];
    gridFilters.forEach((filter) => {
      if (filter === 'locked') {
        filterParams.push({
          fieldName: 'status',
          value: 'locked',
          filterType: 'Equal',
        });
      } else {
        filterRoles.push(filter);
      }
    });
    if (filterRoles?.length > 0) {
      filterParams.push({
        fieldName: 'roles',
        values: filterRoles,
        filterType: 'In',
      });
    }
    return filterParams;
  };

  const handleExportUser = () => {
    if (isExporting) return;

    downloadUserInfoGrid(
      {
        pageIndex: 1,
        pageSize: 999999999,
        filters: getFilterParams(),
        search: {
          searchText: userMaintenanceText,
          primaryFieldsOnly: false,
        },
        fileType: 'Xlsx',
      },
      {
        onError: () => {
          notification.error({
            message: intl.formatMessage(Messages.exportError),
          });
        },
      }
    );
  };

  return (
    <RibbonButton
      icon={<DownloadOutlined />}
      label={Messages.exportToExcel}
      onClick={handleExportUser}
      disabled={isExporting}
      loading={isExporting}
    />
  );
};

export default ExportUserButton;
